import cookie from '@s-ui/js/lib/cookie'

// Other contexts factories
import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
// Notifications factories
import NotificationsValueObjectFactory from '../ValueObjects/factory.js'
// Notifications repositories
import CookieNotificationsRepository from './CookieNotificationsRepository.js'
import EmptyNotificationsRepository from './EmptyNotificationsRepository.js'
import HTTPNotificationsRepository from './HTTPNotificationsRepository.js'

export default class NotificationsRepositoriesFactory {
  static cookieNotificationsRepository = ({config}) =>
    new CookieNotificationsRepository({
      config,
      cookie,
      log: factoryLogger({prefix: 'CookieNotificationsRepository'}),
      pendingPtaVOFactory: NotificationsValueObjectFactory.pendingPtaValueObject,
      userProfileNotificationsValueObjectFactory: NotificationsValueObjectFactory.userProfileNotificationsValueObject
    })

  static httpNotificationsRepository =
    ({config}) =>
    userEntity =>
      new HTTPNotificationsRepository({
        config,
        cookieRepository: NotificationsRepositoriesFactory.cookieNotificationsRepository({
          config
        }),
        fetchOrFail: FetcherFactory.fetchOrFail({
          config
        }),
        log: factoryLogger({prefix: 'HTTPNotificationsRepository'}),
        pendingPtaVOFactory: NotificationsValueObjectFactory.pendingPtaValueObject,
        userEntity
      })

  static emptyNotificationsRepository = () =>
    new EmptyNotificationsRepository({
      pendingPtaVOFactory: NotificationsValueObjectFactory.pendingPtaValueObject,
      unseenSavedSearchMatchesByIdVOFactory: NotificationsValueObjectFactory.unseenSavedSearchMatchesByIdValueObject
    })
}
